export const TEAM_MEMBER_STATUS = {
  STATUS_REQUEST: 1,
  STATUS_ACTIVE: 2,
  STATUS_REJECT: 3,
};

export const TEAM_TYPES = {
  // Команда мероприятия
  stage: 'teams',
  // Команда друзей
  friends: 'friend-teams',
  // Команда тренера
  coaching: 'coaching-teams',
};

export const TEAMS_LIST_SEARCH_TYPE = {
  trainer: 'trainer', // команды у тренера
  event: 'event', // команды внутри мероприятия
};
